import { render, staticRenderFns } from "./BasketMobile.vue?vue&type=template&id=051338c3&"
import script from "./BasketMobile.vue?vue&type=script&lang=js&"
export * from "./BasketMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports